import { compose } from 'redux'
import { withJob } from 'react-jobs'
import { withReducer as withLoginReducer } from '../Login/reducer'
import { withSaga as withLoginSaga } from '../Login/saga'

import { resolveAfter } from '../../utils/timeoutsPromises'

// awaits for login.initFromSession saga
// FIXME: trigger Promise to dont use timeout
const job = withJob({
  work() {
    return resolveAfter(10)
  }
})

export default compose(
  withLoginReducer,
  withLoginSaga,
  job
)
